import { render, staticRenderFns } from "./SearchAlter.vue?vue&type=template&id=858bdffc&scoped=true"
import script from "./SearchAlter.vue?vue&type=script&lang=js"
export * from "./SearchAlter.vue?vue&type=script&lang=js"
import style0 from "./SearchAlter.vue?vue&type=style&index=0&id=858bdffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858bdffc",
  null
  
)

export default component.exports